/**
 * Component for switch button
 *
 * @module components/Switch
 */

import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { openModal } from '../../../actions/Modal';
import { AriaAttributes, AriaRoles } from '../../../constants/AccessibilityConstants';
import { messages as m } from '../../../constants/UserSettings';
import { createBEM } from '../../../lib/utils/css';
import PasswordModalBody from '../../UserSettings/Account/PasswordModalBody';

import './Switch.scss';

class Switch extends React.Component {
  static propTypes = {
    getAuthenticationObject: PropTypes.func,
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,
    offLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    onLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    onToggle: PropTypes.func,
    openModal: PropTypes.func,
    requireAuthentication: PropTypes.bool,
    title: PropTypes.string,
    useDarkTheme: PropTypes.bool,
    useLightTheme: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isDisabled: false,
  };

  state = {
    isChecked: this.props.isChecked,
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.isChecked !== nextProps.isChecked) {
      this.setState({
        isChecked: nextProps.isChecked,
      });
    }
  }

  toggleSwitch = isChecked => {
    this.setState({ isChecked });
    this.props.onToggle && this.props.onToggle(isChecked);
  };

  handleChange = updatedValue => {
    if (this.props.isDisabled) {
      return;
    }
    if (this.props.requireAuthentication) {
      this.props.dispatch(
        openModal({
          modalType: 'ModalCustom',
          body: PasswordModalBody,
          authenticationSettings: this.props.getAuthenticationObject(updatedValue),
          onAuthenticated: () => this.toggleSwitch(updatedValue),
        }),
      );
    } else {
      this.toggleSwitch(updatedValue);
    }
  };

  render() {
    const classes = createBEM('Switch', {
      checked: this.state.isChecked,
      darkTheme: this.props.useDarkTheme,
      lightTheme: this.props.useLightTheme,
    });
    const ariaAttributes = {
      role: AriaRoles.SWITCH,
      [AriaAttributes.CHECKED]: this.state.isChecked,
    };
    const passwordWarning = this.props.requireAuthentication ? (
      <FormattedMessage {...m.passwordRequired} />
    ) : null;
    const visibleLabel = this.state.isChecked ? this.props.onLabel : this.props.offLabel;
    return (
      <div className={classes}>
        <label>
          <span className='visuallyHidden'>{this.props.title}</span>
          {passwordWarning && <span className='Switch__passwordWarning'>{passwordWarning}</span>}
          <button
            type='button'
            className='Switch__slider'
            {...ariaAttributes}
            onClick={() => this.handleChange(!this.state.isChecked)}
          ></button>
        </label>
        {visibleLabel && <span className='Switch__label'>{visibleLabel}</span>}
      </div>
    );
  }
}

export default connect()(Switch);
